import { ApexOptions } from 'ng-apexcharts';

export const lineColor = '#d5d5d9';

export const loadingChartOpts: ApexOptions = {
    chart: {
        height: 450,
        type: 'line',
        animations: {
            enabled: false,
        },
    },
    yaxis: [
        {
            title: { text: '' },
            labels: { show: false },
        },
    ],
    xaxis: {
        type: 'category',
        tooltip: {
            enabled: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: 'smooth' as const,
        width: [10, 10],
        colors: [lineColor],
    },
    markers: {
        size: 0,
        strokeWidth: 0,
    },
    tooltip: { enabled: false },
    colors: [lineColor],
    fill: {
        colors: [lineColor],
    },
    states: { hover: { filter: { type: 'none' } } },
};
